<template>
  <div style="margin-bottom: 1.5rem"
    class="columns is-multiline">
    <div class="column is-6">
      <!-- 서비스 결제 정보 -->
      <div class="box" style="min-height: 477px; padding: 20px">
        <div class="flex-between" style="padding-bottom: 12px; border-bottom: 1px solid #e5e5e5" >
          <div class="box-title">서비스 이용 정보</div>
          <button class="button terminate-btn"
                  v-if="serviceInfo.status===9 && !serviceInfo.terminate_expect_date && !serviceInfo.plan.trial"
                  @click="$refs.serviceTerminate.open()">서비스 해지</button>
          <div v-else-if="serviceInfo.terminate_expect_date">
            {{ datesFormat(serviceInfo.terminate_expect_date, 'date_4') }} 서비스 해지 예정</div>
        </div>
        <service-terminate :service="serviceInfo" ref="serviceTerminate"></service-terminate>
        <div>
          <div  v-if="serviceInfo.service_type === 4"
                class="flex-between" style="padding: 16px 0; border-bottom: 1px solid #f3f3f3">
            <div>
              <div class="grey size-13 weight-500">멤버십/플랜</div>
              <div class="size-14 main weight-500" style="margin-top: 4px">
                {{ serviceInfo.membership_name }}
                <span>({{ serviceInfo.plan.date_unit }}개월)</span>
                <span v-if="serviceInfo.plan.trial"
                      style="margin-left:4px"
                      class="weight-400 primary">무료체험 중</span>
              </div>
              <div v-if="serviceInfo.next_plan" style="margin-top:8px"
                   class="size-13 primary">{{ datesFormat(serviceInfo.next_plan.start_date, 'date_3')}} 이후로
              {{ serviceInfo.next_plan.name }} ({{ serviceInfo.next_plan.date_unit }}개월) 플랜으로 변경됩니다.</div>
            </div>
            <button v-if="showPlanButton"
              class="button is-primary" @click="plan">플랜 {{ serviceInfo.plan.trial ? '결제' : '변경' }}하기</button>
            <button class="button is-primary" v-else-if="serviceInfo.next_plan" @click="clickInquiry">문의하기</button>
          </div>
          <div v-if="serviceInfo.hosting && !serviceInfo.plan.trial"
            style="padding: 16px 0; border-bottom: 1px solid #f3f3f3">
            <div class="grey size-13 weight-500">호스팅</div>
            <div class="size-14 weight-500 main" style="margin-top: 4px">{{ serviceInfo.hosting }}
              <span style="margin-left:4px">(1개월)</span>
            </div>
          </div>
          <div v-for="(opt,oidx) in options" :key="`opt-${oidx}`"
               style="padding: 16px 0; border-bottom: 1px solid #f3f3f3">
            <div class="grey size-13 weight-500">{{ opt.label }}</div>
            <div class="size-14 weight-500 main">{{ optText(opt) }}</div>
          </div>
          <div v-if="serviceInfo.care_service && !serviceInfo.plan.trial"
               style="padding: 16px 0; border-bottom: 1px solid #f3f3f3">
            <div class="grey size-13 weight-500">케어 서비스</div>
            <div class="size-14 weight-500 main" style="margin-top: 4px">{{ serviceInfo.care_service }}
              <span v-if="serviceInfo.care_service_info.date_unit > 0" style="margin-left:4px">({{ serviceInfo.care_service_info.date_unit }}개월)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-half" v-if="!serviceInfo.plan.trial">
      <div class="box" style="min-height: 477px; padding: 20px">
        <div class="flex-between" style="padding-bottom: 12px; border-bottom: 1px solid #e5e5e5" >
          <div class="box-title">결제정보</div>

        </div>
        <div v-if="next_date_info">
          <div>
            <div class="flex-between" style="padding: 16px 0; border-bottom: 1px solid #f3f3f3">
              <div>
                <div class="grey size-13 weight-500">다음 결제 예정 금액 합계</div>
                <div v-if="next_date_info" class="size-14 weight-500 main"
                     style="margin-top: 4px">{{ next_date_info.total_pay_price | currency }}</div>
              </div>
              <button class="button" style="width: 58px"
                      @click="$modal.show('nextDatePriceDetailModal')">상세</button>
            </div>
            <div style="padding: 16px 0; border-bottom: 1px solid #f3f3f3">
              <div class="grey size-13 weight-500">다음 결제 예정일</div>
              <div v-if="next_date_info" class="size-14 weight-500 main"
                   style="margin-top: 4px">{{ datesFormat(next_date_info.next_date, 'date_3') }}</div>
              <div v-else class="size-14 weight-500 main"
                   style="margin-top: 4px">없음</div>
            </div>

            <div class="flex-between" style="padding: 16px 0">
              <div>
                <div class="grey size-13 weight-500">카드정보</div>
                <div class="size-14 weight-500 main" style="margin-top: 4px">
                  {{ serviceInfo.credit_card && serviceInfo.credit_card !== '' ? serviceInfo.credit_card : '-' }}
                </div>
              </div>
              <button class="button" style="width: 58px" @click="regCardBill">수정</button>
            </div>
            <div class="grey size-13">
              *월단위 결제 금액은 모두 다음 결제일에 자동으로 갱신 됩니다.
            </div>
          </div>
        </div>

        <!--<div class="flex-between" style="margin-top:16px;margin-bottom:12px">
          <div>
            <div class="primary size-12">*서비스 신청 7일 이내에는 3개월 플랜 신청이 가능합니다.</div>
            <div class="primary size-12">*플랜 변경 및 서비스 일시정지을 원하시는 경우, 1:1 문의하기를 통해 문의해 주시기 바랍니다</div>
          </div>
          <button class="button is-primary-light"
                  style="width:110px;margin-left:24px"
                  @click="routerPush(getPath('launchpack/inquiry/customer/create'))">1:1 문의 바로가기
          </button>
        </div>-->

        <user-billing-modal v-if="vBill" :radio="true" @close="vBill=false" @select="onSelectBill"></user-billing-modal>

        <!--<modal name="regBillModal" :adaptive="true" height="auto" class="modal-style">
          <div class="lp-modal-wrapper">
            <billing-form ref="form" :service="serviceInfo" @done="billingDone" @close="$modal.hide('regBillModal')"></billing-form>
          </div>
        </modal>-->

        <modal name="appMarketPriceDetailModal" :adaptive="true" :width="1200" height="auto" class="modal-style">
          <div class="lp-modal-wrapper">
            <div class="flex-between" style="margin-bottom:64px">
              <div class="size-21" style="color:#363636">청구서</div>
              <img :src="svgSrc('fi_close_outline')" class="svg-sub2 unselect"
                   @click="$modal.hide('appMarketPriceDetailModal')">
            </div>
            <market-price-detail-modal :service="serviceInfo"></market-price-detail-modal>
          </div>
        </modal>

        <modal name="nextDatePriceDetailModal" :adaptive="true" :width="1200" height="auto" class="modal-style">
          <div class="lp-modal-wrapper">
            <div class="flex-between" style="margin-bottom:64px">
              <div class="size-21" style="color:#363636">청구 예정 내역</div>
              <img :src="svgSrc('fi_close_outline')" class="svg-sub2 unselect"
                   @click="$modal.hide('nextDatePriceDetailModal')">
            </div>
            <next-date-price-detail-modal :service="serviceInfo" :next_date_info="next_date_info"></next-date-price-detail-modal>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>
<script>
  import ServiceTerminate from "./ServiceTerminate";
  import { SweetModal } from "sweet-modal-vue"
  import BillingForm from "./BillForm";
  import MarketPriceDetailModal from "./MarketPriceDetailModal";
  import NextDatePriceDetailModal from "./NextDatePriceDetailModal";
  import UserBillingModal from "./UserBillingModal";
  export default {
    name: "ServicePayInfo",
    components: {
      UserBillingModal,
      NextDatePriceDetailModal,
      MarketPriceDetailModal,
      BillingForm,
      ServiceTerminate,
      SweetModal
    },
    created() {
      this.getLaunchpackService();
    },
    data() {
      return {
        service: undefined,
        next_date_info: undefined,
        vBill: false,
        options: [
          { label: '팩', value: 'kor_packages' },
          { label: '플러그인', value: 'kor_plugins' },
          { label: '부가서비스', value: 'kor_service' }
        ]
      }
    },
    computed: {
      showPlanButton() {
        return this.$store.getters.mode === 'admin' && this.checkServiceVersion(2) && !this.serviceInfo.next_plan;
      }
    },
    watch: {
      serviceInfo: {
        handler() {
          this.getLaunchpackService();
        },
        deep: true
      }
    },
    methods: {
      clickInquiry() {
        this.routerPush('/office/admin/launchpack/inquiry/customer/create');
      },
      optText(opt) {
        return this.serviceInfo[opt.value].length > 0 ?
          this.serviceInfo[opt.value].reduce((a, c) => a === '' ? c : a + ', ' + c, '') : '-';
      },
      plan() {
        this.$root.$emit('planChangeModal');
      },
      regCardBill() {
        this.$modal.show('regBillModal');
        this.vBill = true;
      },
      getLaunchpackService() {
        this.getSerivceNextDateInfo();
        // 플랜 변경 모달 열기
        if(this.$route.query.token) {
          this.$nextTick(()=>{
            this.plan();
            this.$router.replace(location.pathname)
          })
        }
      },
      getSerivceNextDateInfo() {
        let url = `${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/v1/service/${this.serviceInfo.id}/next_date/info`;
        this.$axios.get(url).then(res => {
          this.next_date_info = res.data;
        })
      },
      onSelectBill(item) {
        this.$axios.post(`${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/card_bill/service/${this.$store.getters.masterService.service_id}`, {'user_bill': item.id}).then(res=>{
          if(res.status === 200) {
            this.serviceInfo.credit_card = `${item.num} / ${item.card_name}`;
          }
        });
      },
      billingDone() {
        if(!this.$refs.form.validate()) {
          this.toast('카드 정보를 제대로 입력해주세요.');
          return;
        }
        // let url = `http://localhost:8001/serviceadmin/${this.$store.getters.admin.id}/launchpack/v1/service/${this.serviceInfo.id}/reg_bill_payple`;
        let url = this.masterBackendUrl + `serviceadmin/${this.$store.getters.admin.id}/launchpack/v1/service/${this.serviceInfo.id}/reg_bill_payple`;
        let params = this.cloneItem(this.$refs.form.value);
        params.user_id = this.serviceInfo.user;
        params.service_key = this.serviceInfo.key;
        this.$store.commit('setLoading', true);
        this.$axios.post(url, params).then(res=>{
          this.$store.commit('setLoading', false);
          if(res.data.result==='success') {
            this.toast('카드 등록이 완료되었습니다.');
            this.$modal.hide('regBillModal');
            this.getLaunchpackService();
          }
          else if(res.data.message.indexOf('CDAU1002')>-1) {
            this.toast(res.data.message.replace('[CDAU1002] ',''));
          } else {
            this.toast('카드 정보가 잘못 입력되었습니다.');
            Object.keys(this.$refs.form.err).forEach((key=>{
              this.$refs.form.err[key].err = false;
            }));
            for(let item of [
              { code: '3110', key: 'card_num' },
              { code: '3115', key: 'pw' },
              { code: '3119', key: 'ex' },
              { code: '3131', key: 'birth' }
            ]) {
              if(res.data.message.indexOf(item.code)>-1) {
                this.$refs.form.err[item.key].err = true;
              }
            }
          }
        }).catch(error=>{
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .grey
    color $grey
  .box:not(:last-child)
    margin-bottom 0
  .service-order-wrapper
    display grid
    grid-template-columns 4fr 1fr
    grid-gap 0 32px
    align-items flex-start
  .box-sub-title
    font-size 13px
    color $sub3
    width 110px

  .box-sub-content
    font-size 13px
    color $main

  .box-title
    font-size 21px
    color $main
    font-weight 400

  .plan-change-modal-title
    background-color #000000
    width 100%
    height 56px
    color white
    display flex
    align-items center
    padding  12px 24px
  .terminate-btn
    background-color white
    color $main
    font-size 12px
    font-weight 400

</style>
